module.exports = __webpack_public_path__ + "static/15-4af42501df3cc7f65d58db5047847e45.jpg";